const valores_curso = (cs) => {
  let de_por =
    cs.valor_ficticio == 0
      ? `de R$${(cs.valor * 1.3).toFixed(0)},00`
      : `de R$${cs.valor_ficticio},00`;
  let avista = `R$${(cs.valor * 0.9).toFixed(0)},00`;
  let parcelas = (cs.valor / 10).toFixed(2);
  let parcelado_html = ``;
  parcelado_html = `R$${parcelas.replace(".", ",")}`;

  if (
    cs.id == "3840" ||
    cs.id == "4064" ||
    cs.id == "4134" ||
    cs.id == "5132"
  ) {
    parcelas = (cs.valor / 12).toFixed(2);
    parcelado_html = `R$${parcelas.replace(".", ",")}`;
  }

  if (
    cs.valor == 0 &&
    cs.id != "3560" &&
    cs.id != "3238" &&
    cs.id != "3497" &&
    cs.id != "4111" &&
    cs.id != "1409" &&
    cs.id != "4136" &&
    cs.id != "3247" &&
    cs.id != "4114" &&
    cs.id != "3640" &&
    cs.id != "4108" &&
    cs.id != "3641"
  ) {
    de_por = "de R$97,00";
  }
  return { de_por, avista, parcelas, parcelado_html };
};

export default valores_curso;
